<template>
	<div class="grid-flex-container pa-4">
		<div style="flex-grow: 1">
			<v-form ref="form">
				<v-text-field
					v-model="formProject.Name"
					name="Name"
					label="Name"
					:rules="nameRules"
					required
				/>
				<v-text-field
					v-if="formProject.Id && canViewProjectId"
					v-model="formProject.Id"
					name="Id"
					label="Project ID"
					disabled
				/>
				<v-text-field
					v-model="formProject.Description"
					name="Description"
					label="Description"
					required
				/>
			</v-form>
			<v-row v-if="formProject.Id">
				<v-col
					style="
						background-color: #ffc00030;
						display: flex;
						justify-content: flex-end;
						align-content: space-between;
					"
				>
					<div
						v-if="formProject.DbConnection"
						style="display: flex; align-items: center"
					>
						<p style="font-size: 80%; margin-bottom: 0">
							<b>
								Server Name:
								{{ formProject.DbConnection.SqlServerName }}
								; Database Name:
								{{ formProject.DbConnection.DatabaseName }}
							</b>
						</p>
					</div>
					<div
						v-if="formProject.DbConnection == null"
						style="display: flex; align-items: center"
					>
						<p style="font-size: 80%; margin-bottom: 0">
							<b>There is no DbConnection defined yet</b>
						</p>
					</div>

					<v-spacer />
					<v-btn
						v-if="formProject.Id && showDbButton"
						color="primary"
						@click="dbConnectionSetup()"
					>
						<v-icon class="mr-2">mdi-content-save</v-icon>
						DbConnectionSetup
					</v-btn>
				</v-col>
			</v-row>
			<v-row v-if="formProject.Id">
				<v-col>
					<v-btn
						color="primary"
						class="mr-2 mt-2"
						@click="createIntegrationApiKey()"
						>Create Integration Api Key</v-btn
					>
					<v-text-field
						readonly
						v-model="formProject.IntegrationApiKey"
						placeholder="No Integration Api Key Created"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row v-if="formProject.Id && canViewSwaggerUrl">
				<v-col>
					<v-text-field
						readonly
						v-model="swaggerUrl"
						label="Swagger URL for Mobile Module"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row v-if="formProject.Id && canViewOdataUrl">
				<v-col>
					<v-text-field
						readonly
						v-model="odataUrl"
						label="Project Odata URL"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row no-gutters v-if="formProject.Logo">
				<v-img
					class="my-2"
					v-if="formProject.Logo"
					:src="getProjectLogoURL(formProject.Logo)"
					max-height="200"
					max-width="200"
				/>
				<v-btn
					class="action-btn"
					fab
					small
					icon
					elevation="1"
					color="error"
					@click.stop="deleteProjectLogo"
				>
					<v-icon small> mdi-delete</v-icon>
				</v-btn>
			</v-row>
			<v-row no-gutters v-else>
				<v-file-input
					v-model="logo"
					counterlabel="File input"
					placeholder="Select project Logo"
					prepend-icon="mdi-paperclip"
					dense
					accept="image/*"
					show-size
				/>
			</v-row>
		</div>

		<v-spacer />
		<v-card-actions>
			<v-spacer />
			<v-btn text outlined @click="onCancel"> Cancel </v-btn>
			<v-btn color="primary" @click="onSubmit">
				<v-icon class="mr-2">mdi-content-save</v-icon>
				Save
			</v-btn>
		</v-card-actions>
		<db-connection
			v-if="showDialog"
			:showDialog="showDialog"
			:dbConnection="dbConnection"
			@save="submitDbConnection"
			@cancel="cancelDbConnection"
		/>
	</div>
</template>
<script>
import { ProjectManagementActions } from '../../store/actions';
import {
	ProjectManagementGetters,
	ClientContextGetters,
} from '../../store/getters';
import { ProjectContextActions } from '../../store/actions';
import { mapGetters } from 'vuex';
import DbConnection from '../../components/shared/DbConnection.vue';
import { Permissions } from '../../enums/permissionsEnum';
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import permissionsMixin from '../../mixins/permissionsMixin';
import vueAppSubfolder from '../../utils/appSubfolderUtils';
export default {
	name: 'AddEditProjectModal',
	components: { DbConnection },
	mixins: [permissionsMixin],
	data() {
		return {
			logo: null,
			method: '',
			id: '',
			showDialog: false,
			nameRules: [(v) => !!v || 'Name is required'],
		};
	},
	computed: {
		...mapGetters({
			selectedProject: [ProjectManagementGetters.GET_SELECTED_PROJECT],
			dbConnection: [ProjectManagementGetters.GET_DBCONNECTION],
			selectedClient: [ClientContextGetters.SELECTED_CLIENT],
		}),
		showDbButton() {
			if (this.dbConnection) return false;
			return true;
		},
		odataUrl() {
			let param = this.selectedClient.Host;
			if (vueAppSubfolder.get() && vueAppSubfolder.get() != '/')
				param = param + vueAppSubfolder.get();
			return `https://${param}/mobilemodule/projects/${this.$route.params.id}/ODATA`;
		},
		swaggerUrl() {
			let param = this.selectedClient.Host;
			if (vueAppSubfolder.get() && vueAppSubfolder.get() != '/')
				param = param + vueAppSubfolder.get();
			return `https://${param}/MobileModule/swagger/index.html`;
		},
		canViewSwaggerUrl() {
			return this.hasPermissions([
				Permissions.ProjectManagement.CanViewSwaggerUrl,
			]);
		},
		canViewOdataUrl() {
			return this.hasPermissions([
				Permissions.ProjectManagement.CanViewOdataUrl,
			]);
		},
		canViewProjectId() {
			return this.hasPermissions([
				Permissions.ProjectManagement.CanViewProjectId,
			]);
		},
		loginTest: {
			get() {
				if (this.selectedProject && this.selectedProject.LoginMethod) {
					return this.loginItems.find(
						(x) => x.id == this.selectedProject.LoginMethod
					).id;
				}
				return null;
			},
			set(val) {
				this.formProject.LoginMethod = val;
			},
		},
		formProject() {
			return Object.assign({}, this.selectedProject);
		},
	},
	destroyed() {
		this.$store.dispatch(ProjectManagementActions.CLEAR_SELECTEDPROJECT);
	},
	mounted() {
		if (this.$route.params.id) {
			this.id = this.$route.params.id;
			this.$store
				.dispatch(
					ProjectManagementActions.LOAD_DATA_PROJECTID,
					this.$route.params.id
				)
				.then(() => {});
		}
	},
	methods: {
		getProjectLogoURL(image) {
			let path =
				window.location.origin +
				(process.env.VUE_APP_SUBFOLDER === '/'
					? ''
					: process.env.VUE_APP_SUBFOLDER) +
				'/uploads';
			path = path + image;
			return path;
		},
		deleteProjectLogo() {
			ConfirmDialog({
				message: 'Are you sure you want to delete this logo?',
			}).then((isDelete) => {
				if (!isDelete) return;
				this.$store.dispatch(
					ProjectManagementActions.REMOVE_LOGO,
					this.formProject
				);
			});
		},
		createIntegrationApiKey() {
			this.$store.dispatch(
				ProjectManagementActions.CREATE_INTEGRATION_API_LEY,
				this.$route.params.id
			);
		},
		copyToClipboard(text) {
			navigator.clipboard.writeText(text);
		},
		submitDbConnection(item) {
			item.ProjectId = this.selectedProject.Id;
			if (item.Id) {
				this.$store
					.dispatch(ProjectManagementActions.UPDATE_DBCON, item)
					.then(() => {
						this.showDialog = false;
						this.loadData();
					});
			} else {
				this.$store
					.dispatch(
						ProjectManagementActions.LOAD_DB_BYCLIENTNAME,
						item.DatabaseName
					)
					.then((resp) => {
						if (resp)
							this.$store
								.dispatch(
									ProjectManagementActions.INSERT_DBCON,
									item
								)
								.then(() => {
									this.$store.dispatch(
										ProjectContextActions.RELOAD_PROJECT_CONTEXT
									);
									this.showDialog = false;
									this.loadData();
								});
					});
			}
		},
		cancelDbConnection() {
			this.showDialog = false;
		},
		dbConnectionSetup() {
			this.showDialog = true;
		},
		onSubmit() {
			if (this.$refs.form.validate()) {
				this.formProject.ClientId = Number(this.formProject.ClientId);
				if (this.formProject.Id) {
					this.$store.dispatch(ProjectManagementActions.UPDATE, {
						item: this.formProject,
						logo: this.logo,
					});
				} else {
					this.$store
						.dispatch(ProjectManagementActions.INSERT_PROJECT, {
							item: this.formProject,
							logo: this.logo,
						})
						.then(() => {
							let id = this.selectedProject.Id;
							this.$router.push({
								name: 'ProjectsManagementEdit',
								params: { id: id },
							});
						});
				}
			}
		},
		onCancel() {
			this.$emit('cancel');
			this.$router.push({
				name: 'Projects',
			});
		},
		loadData() {
			this.$store.dispatch(
				ProjectManagementActions.LOAD_DATA_PROJECTID,
				this.$route.params.id
			);
		},
	},
};
</script>
